import { Box } from '@palmetto/palmetto-components';

import { useAppSelector } from './hooks/useAppSelector';

export const RateLimitBanner = () => {
  const { showRateLimitBanner } = useAppSelector((state) => state.rateLimit);

  if (showRateLimitBanner) {
    return (
      <Box background="warning" padding="md">
        Rate limit exceeded. Please try again later. Reach out to support if you need higher limits.
      </Box>
    );
  }

  return null;
};
